import { render, staticRenderFns } from "./ChooseOrUploadAnimations.vue?vue&type=template&id=4c45bf53&"
import script from "./ChooseOrUploadAnimations.vue?vue&type=script&lang=js&"
export * from "./ChooseOrUploadAnimations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports